import { render, staticRenderFns } from "./ClienteAlterar.vue?vue&type=template&id=861c73d0&scoped=true"
import script from "./ClienteAlterar.vue?vue&type=script&lang=js"
export * from "./ClienteAlterar.vue?vue&type=script&lang=js"
import style0 from "./ClienteAlterar.vue?vue&type=style&index=0&id=861c73d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "861c73d0",
  null
  
)

export default component.exports